import * as React from "react";
import {Component } from "react";

import "./footer.scss";

import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {UiState} from "../../../core/ui-state";
import {observer} from "mobx-react";
import {AppConfiguration} from "../../../core/config/app-configuration";
import SVG from "react-inlinesvg";
import facebookLogo from "../../../assets/images/layout/facebook.svg";
import twitterLogo from "../../../assets/images/layout/twitter.svg";


export interface FooterProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
}

@observer
export class AuftragsverwaltungFooter extends Component<FooterProps, any> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    render(): React.ReactElement | null {
        const {topic} = this.props.appStore;
        const pageTitle = document.title;
        const locationHref = window.location.href;
        if (!topic) {
            return null;
        }
        return(
            <footer className="footer">
                <div className="footer__content">
                    <ul className="footer__content-linklist">
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" href="https://www.lu.ch">
                                © {new Date().getFullYear()} Kanton Luzern</a><span className="line" />
                        </li>
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" title="Impressum"
                                href="https://www.egovernment-luzern.ch/Impressum"
                                rel={"noreferrer"} target="_blank">Impressum</a><span className="line" />
                        </li>
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" title="Disclaimer"
                                href="https://www.egovernment-luzern.ch/Disclaimer"
                                rel={"noreferrer"} target="_blank">Disclaimer</a>
                        </li>
                    </ul>
                    <ul className="footer__content-social-media">
                        <li id="ctl05_liFacebook"
                            className="footer__content-social-media-item footer__content-social-media-item--facebook">
                            <a title={"Teile diese Seite auf Facebook"}
                                className="footer__content-social-media-item-url"
                                href={"https://www.facebook.com/sharer.php?u=" +
                                encodeURIComponent(locationHref) +
                                "&t=" + encodeURIComponent(pageTitle) + ""}
                                rel={"noreferrer"} target="_blank"><span className="sprite sprite--facebook">
                                    <SVG src={facebookLogo}/>
                                </span></a>
                        </li>
                        <li id="ctl05_liTwitter"
                            className="footer__content-social-media-item footer__content-social-media-item--twitter">
                            <a title="Twitter" className="footer__content-social-media-item-url"
                                href={"https://twitter.com/intent/tweet?original_referer=" +
                                encodeURIComponent(locationHref) +
                                "&text=" + encodeURIComponent(pageTitle) + ""}
                                rel={"noreferrer"} target="_blank"><span className="sprite sprite--twitter">
                                    <SVG src={twitterLogo}/>

                                </span></a>
                        </li>
                    </ul>
                </div>

            </footer>
        );
    }
}
